/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S6_TitleInputs */

const en_fc_tut_s6_title = /** @type {(inputs: Fc_Tut_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct and grade color`)
};

/**
* | output |
* | --- |
* | "Correct and grade color" |
*
* @param {Fc_Tut_S6_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s6_title = /** @type {((inputs?: Fc_Tut_S6_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S6_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s6_title(inputs)
});
export { fc_tut_s6_title as "fc.tut.s6.title" }